<template>
  <div>
    <!-- 内容区 -->
    <div class="content w">
      <!-- <img :src="imgUrl" class="imgUrl" v-if="detailInfo.certifyTag == 1" /> -->
      <div class="car_img_swipe">
        <div class="thumb-example">
          <!-- swiper1 -->
          <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide class="slide-1" v-for="(item, index) in detailInfo.pics" :key="index">
              <img :src="item.picUrl" alt="" />
            </swiper-slide>
            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
          </swiper>
          <!-- swiper2 Thumbs -->
          <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
            <swiper-slide class="slide-1" v-for="(item, index) in detailInfo.pics" :key="index">
              <img :src="item.picUrl" alt="" />
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="car_base_info">
        <div class="car_name">{{ detailInfo.vehicleName || '' }}</div>
        <div class="car_text_box">
          <div class="left_box">
            <div class="car_text">车辆编号：{{ detailInfo.stockNumber }}</div>
            <div class="car_price" v-if="detailInfo.showPrice">
              标价：<span>￥{{ detailInfo.showPrice }}</span> 万元
            </div>
            <div class="car_text" v-if="detailInfo.newcarPrice">新车价：￥{{ detailInfo.newcarPrice }}万元</div>
            <div class="car_text_ts" v-if="detailInfo.differPrice">为您省￥{{ detailInfo.differPrice }}万元</div>
            <div class="car_text_ts">价格以现场看车为准</div>
          </div>
         <div class="right_box">
            <div class="car_text" v-if="detailInfo.publishDate">发布日期：{{ detailInfo.publishDate }}</div>
<!--            <div class="car_text" v-if="detailInfo.downPayments">汽车金融分期付款方案：</div>
            <div class="car_text_price" v-if="detailInfo.downPayments">首付{{ detailInfo.downPayments }}万元把车开回家</div>
            <div class="car_text_ts">具体金融方案咨询市场客服中心</div>-->
          </div>
        </div>
        <div class="car_info">
          <div>
            <span>上牌时间</span>
            <span>{{ detailInfo.registMonth || '-' }}</span>
          </div>
          <p></p>
          <div>
            <span>行驶里程</span>
            <span>{{ detailInfo.mileageCount || '-' }}万公里</span>
          </div>
          <p></p>
          <div>
            <span>排量</span>
            <span>{{ detailInfo.outputVolume || '-' }}{{ detailInfo.outputVolumeU }}</span>
          </div>
          <p></p>
          <div>
            <span>排放标准</span>
            <span>{{ detailInfo.envLevel || '-' }}</span>
          </div>
          <p></p>
          <div>
            <span>车身颜色</span>
            <span>{{ detailInfo.color || '-' }}</span>
          </div>
        </div>
        <div class="car_tel">
          <div>
            <span>市场：{{ detailInfo.marketName || '-' }}</span>
            <span>店铺：{{ detailInfo.companyName || '-' }}</span>
          </div>
          <div>
            <span>手机号：{{ detailInfo.phone || '-' }}</span>
            <span>点击量：{{ detailInfo.hits || '-' }}</span>
          </div>
        </div>
        <div class="car_operate">
          <span class="btn" @click="addContrast">加入对比<i class="el-icon-circle-plus-outline"></i></span>
          <!-- <span>淘宝直播<i class="el-icon-right"></i></span> -->
          <span class="btn">
            <el-dropdown @command="toPlatformNote">
              <span style="color:#fff;">直播列表<i class="el-icon-arrow-down el-icon--right"></i> </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in livePlatformList" :key="index" :command="item.platformUrl">{{ item.platformNote }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown></span
          >
        </div>
      </div>
    </div>

    <!-- 配置区 -->
    <div class="configuration w">
      <el-tabs v-model="activeName" @tab-click="tabsChange" type="card">
        <el-tab-pane label="车辆信息" name="first">
          <div class="content_box content_box1">
            <div class="content_title">
              车辆信息
            </div>
            <div class="car_info">
              <el-tabs type="border-card">
                <el-tab-pane :label="item.title" v-for="(item, index) in vehicleConfig" :key="index">
                  <div class=" car_info" v-if="index == vehicleConfig.length - 1">
                    <div v-for="(itemA, indexA) in item.chlidren" :key="indexA">
                      <div class="car_info_title">{{ itemA.title }}</div>
                      <div class="car_info_box">
                        <div class="car_params" v-for="(itemB, indexB) in itemA.tiems" :key="indexB">
                          <span>{{ itemB.k }}</span>
                          <span>{{ itemB.v || '暂无' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="car_info_box" v-else>
                    <div class="car_params" v-for="(itemA, indexA) in item.tiems" :key="indexA">
                      <span>{{ itemA.k }}</span>
                      <span>{{ itemA.v || '暂无' }}</span>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="车辆图片" name="second">
          <div class="content_box content_box2">
            <div class="content_title">
              车辆图片
            </div>
            <div class="car_pic">
              <div v-for="(item, index) in detailInfo.pics" :key="index">
                <img :src="item.picUrl" alt="" />
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="检测报告" name="third" v-if="detailInfo.certifyTag == 1">
          <div class="content_box content_box3">
            <div class="content_title">
              检测报告
            </div>
            <div v-if="reportPicUrl">
              <img :src="reportPicUrl" alt="" />
            </div>
            <div v-if="reportH5Url">
              <div class="ts" style="margin-top: 10px;margin-bottom: 10px;margin-left: 13px;color: #5daf34;">
                检测报告由维真验车提供，点击查看>>
              </div>
              <div style="display: flex;justify-content: center;align-items: center">
              <a :href="reportH5Url" target="_blank" >
              <img src="../assets/img/wz_logo.png" style="width:100%" alt="点击查看报告" />
              </a>
              </div>
            </div>
            <div class="con" v-if="isNotObjectEmpty(reportInfo)">
              <div class="ts">温馨提醒：认证二手车源必须达到以下标准</div>
              <div class="ts1">
                <div>无重大事故</div>
                <div>无火烧事故</div>
                <div>无泡水事故</div>
              </div>
              <div class="ts2">
                <!-- <div>
                  <span>事故车检测</span>
                  <span>14项<img src="../assets/img/gou.png" alt=""/></span>
                </div>
                <div>
                  <span>事故车检测</span>
                  <span>14项<img src="../assets/img/gou.png" alt=""/></span>
                </div>
                <div>
                  <span>事故车检测</span>
                  <span>14项<img src="../assets/img/gou.png" alt=""/></span>
                </div> -->
                <div  v-for="(item, index) in reportInfo.categoryList" :key="index">
                  <span>{{ item.title }}</span>
                  <span>{{ item.normal }}项<img src="../assets/img/gou.png" alt=""/></span>
                </div>
              </div>
            <div class="report-tip">三大区域模块检测</div>
            <div class="report-info">
              <div class="report-head">
                  <div class="report-head-son"  v-for="(item, index) in reportInfo.categoryList" :key="index">
                     <img src="../assets/img/gou1.png" alt="" />
                     <div>{{ item.normal }}项  {{ item.title }}</div>
                     <div style="color:#22ac38;">正常</div>
                  </div>
              </div>
              <div class="report-son">
                      <div class="report-son-list" v-for="(item, index) in reportInfo.categoryList" :key="index">
                        <div class="list-head"> {{ item.normal }}项  {{ item.title }} </div>
                        <div class="list-son" v-for="(info, i) in item.itemList" :key="i" >
                           <img src="../assets/img/gou1.png" alt="" v-if="info.itemState == 1"/>
                           <img v-else src="../assets/img/jg.png">
                           <div>{{ info.itemName }}</div>
                           <div  v-if="info.itemState != 1" style="margin-left:5px;color:red;">({{ info.itemErrMsg }})</div>
                        </div>
                      </div>
                  </div>
            </div>
          </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- 列表 -->
    <div class="w car_list_box">
      <div class="title">
        <h3>您可能会喜欢</h3>
      </div>
      <div class="car_list">
        <el-row :gutter="25">
          <el-col :span="6" v-for="item in vehicleLikeList" :key="item.tradeId">
            <!-- <img :src="imgUrl" class="imgUrl" v-if="item.certifyTag == 1" /> -->
            <div class="car_box" @click="changeDetail(item.tradeId)">
              <div class="car_img">
                <img v-if="item.coverUrl" :src="item.coverUrl" />
                <img v-else src="../assets/img/default-car.png" fit="contain" />
              </div>
              <div class="car_name">{{ item.vehicleName }}</div>
              <div class="car_text">
                <span v-if="item.registMonth">{{ item.registMonth }} </span>
                <span v-if="item.mileageCount">{{ item.mileageCount }}万公里</span>
              </div>
              <div class="car_price">
                <span class="dealDate" v-if="item.showPrice">{{ item.showPrice }}万</span>
                <span v-if="item.downPayments">￥首付{{ item.downPayments }}万</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  inject: ['reload'],
  data() {
    return {
      swiperOptionTop: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 5, // looped slides should be the same
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      activeName: 'first',
      // 车辆信息
      detailInfo: '',
      // 车辆配置
      vehicleConfig: '',
      // 猜你喜欢列表
      vehicleLikeList: '',
      // 直播列表
      livePlatformList: [],
      // 检测图片
      reportPicUrl: '',
      reportH5Url: '',
      imgUrl: '',
      reportInfo: {}

    }
  },
  created() {
    if (this.$route.query.tradeId) {
      this.tradeId = this.$route.query.tradeId
    }
    sessionStorage.setItem('menuActive', 0)
    // 更新点击量
    this.updateHits()
    // 车辆信息
    this.getCarDetailInfo()

    // 猜你喜欢
    this.getVehicleLikeList()
    this.getLivePlatformList()
    this.comm()
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.$swiper
      const swiperThumbs = this.$refs.swiperThumbs.$swiper
      swiperTop.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperTop
    })
  },
  methods: {
    async comm() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/config/index', {
        params: {
          keys: 'index_fxc_imgurl'
        }
      })
      if (data.success) {
        this.imgUrl = data.data.list[0].v
      }
    },
    async updateHits() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/hits', {
        params: {
          tradeId: this.tradeId
        }
      })
      if (data.success) {
      }
    },
    onIframeLoad() {
      const iframe = this.$refs.iframe
      const iframeDoc = iframe.contentDocument || iframe.contentWindow.document
      const iframeContentHeight = iframeDoc.body.scrollHeight
      iframe.style.height = `${iframeContentHeight}px`
    },
    isNotObjectEmpty(obj) {
      return Object.keys(obj).length > 0
    },
    async getCarDetailInfo() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleDetail', {
        params: {
          tradeId: this.tradeId
        }
      })
      if (data.success) {
        this.detailInfo = data.data.carsInfo
        // 车辆配置
        this.getVehicleConfig()
      }
    },
    async getVehicleConfig() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/kindConfig?kindId=' + this.detailInfo.kindId)
      if (data.success) {
        this.vehicleConfig = data.data.list
      }
    },
    async getVehicleLikeList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/vehicleLikeList?tradeId=' + this.tradeId)
      if (data.success) {
        this.vehicleLikeList = data.data.page.rows
      }
    },
    async getLivePlatformList() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/livePlatform/list')
      if (data.success) {
        this.livePlatformList = data.data.list
      }
    },
    async tabsChange(tab, e) {
      console.log(tab.name)
      if (tab.name == 'third') {
        const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/certifyReport?tradeId=' + this.tradeId)
        if (data.data.reportDetail.kind == 0) {
          this.reportPicUrl = data.data.reportDetail.reportPicUrl
        } else if (data.data.reportDetail.kind == 1) {
          this.reportH5Url = data.data.reportDetail.pcReportUrl
          window.open(data.data.reportDetail.pcReportUrl)
        } else if (data.data.reportDetail.kind == 2) {
          this.reportInfo = data.data.reportDetail
        }
      }
    },
    changeDetail(id) {
      this.$router.push({
        path: '/car-detail',
        query: {
          tradeId: id
        }
      })
      this.reload()
    },
    // 加入对比
    addContrast() {
      var contrastIdList = JSON.parse(window.sessionStorage.getItem('contrastIdList'))
      if (contrastIdList) {
        var index = contrastIdList.findIndex(item => item == this.tradeId)
        if (index == -1) {
          if (contrastIdList.length == 4) {
            this.$message('车辆对比列表已满')
            return false
          } else {
            contrastIdList.push(this.tradeId)
            window.sessionStorage.setItem('contrastIdList', JSON.stringify(contrastIdList))
            this.$message({
              message: '该车辆加入对比成功',
              type: 'success'
            })
          }
        } else {
          this.$message('该车辆已加入对比')
        }
      } else {
        contrastIdList = []
        contrastIdList.push(this.tradeId)
        window.sessionStorage.setItem('contrastIdList', JSON.stringify(contrastIdList))
        this.$message({
          message: '该车辆加入对比成功',
          type: 'success'
        })
      }
    },
    // 直播
    toPlatformNote(url) {
      window.open(url)
    }
  },
  computed: {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.nav_bar {
  background-color: #f5f5f5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.content {
  margin: 40px auto;
  display: flex;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3);
  position: relative;
  .imgUrl {
    position: absolute;
    width: 5rem;
    height: 5rem;
    right: 1rem;
  }
}

.car_img_swipe {
  width: 580px;
  height: 520px;
  .thumb-example {
    height: 520px;
  }
  .swiper {
    .swiper-slide {
      background-size: cover;
      background-position: center;
      &.slide-1 {
        background: #111;
      }
      &.slide-2 {
        background: #222;
      }
      &.slide-3 {
        background: #333;
      }
      &.slide-4 {
        background: #444;
      }
      &.slide-5 {
        background: #555;
      }
    }
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    &.gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: 10px 0;
    }
    &.gallery-thumbs .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
}
.car_base_info {
  flex: 0 0 50%;
  padding: 20px;
  margin-left: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .car_name {
    font-size: 20px;
  }
  .car_text_box {
    height: 140px;
    display: flex;
    .left_box {
      width: 50%;
      border-right: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .car_text {
        line-height: 2;
      }
      .car_price {
        span {
          font-size: 20px;
          color: #2e71b8;
        }
      }
      .car_text_ts {
        color: #2e71b8;
        line-height: 2;
      }
    }
    .right_box {
      width: 50%;
      display: flex;
      flex-direction: column;
     /* justify-content: space-around;*/
      padding-left: 20px;
      .car_text_price {
        font-size: 20px;
        color: #fb6345;
      }
      .car_text_ts {
        color: #2e71b8;
      }
    }
  }
  .car_info {
    display: flex;
    height: 100px;
    justify-content: space-around;
    background-color: #f2f2f2;
    align-items: center;
    div {
      width: 20%;
      height: 80%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
    }
    p {
      height: 80%;
      border-right: 1px solid #ccc;
    }
  }
  .car_tel {
    line-height: 40px;
    background-color: #f2f2f2;
    padding-left: 20px;
    span {
      margin-right: 20px;
    }
  }
  .car_operate {
    line-height: 40px;
    padding-left: 20px;
    display: flex;
    justify-content: flex-end;
    .btn {
      margin-left: 20px;
      background-color: #2e71b8;
      border-radius: 10px;
      padding: 0 15px;
      color: #fff;
      cursor: pointer;
      color: #fff;
    }
  }
}

.configuration {
  margin-bottom: 30px;
  .content_box {
    padding: 10px;
    .content_title {
      border-left: 3px solid #2e71b8;
      padding-left: 10px;
      font-size: 22px;
    }
  }
}
.content_box1 {
  .car_info {
    margin-top: 20px;
    .car_info_box {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      .car_params {
        width: 31%;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #ccc;
        margin-right: 25px;
        line-height: 2.5;
      }
    }
    .car_info_title {
      line-height: 2.5;
      font-weight: 700;
    }
  }
}
.content_box2 {
  .car_pic {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    div {
      flex: 0 0 49%;
      height: 432px;
      margin-top: 20px;
    }
  }
}
.content_box3 {
  .con {
    width: 100%;
    border: 1px solid #ccc;
    margin: 20px auto;
    .ts {
      text-align: center;
      height: 60px;
      line-height: 60px;
    }
    .ts1 {
      display: flex;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px dashed #ccc;
      div {
        width: 33%;
        text-align: center;
      }
    }
    .ts2 {
      display: flex;
      height: 60px;
      line-height: 60px;
      div {
        width: 33%;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        img {
          width: 15px;
          height: 15px;
        }
      }
    }
  }
}
.report-tip{
  height: 40px;
  line-height: 40px;
  background-color: #f7f7f7;
  color: #495056;
  font-size: 16px;
  padding: 0 1%;
  margin-bottom: 26px;
}
.report-info{
  .report-head{
    display:flex;
    justify-content: space-around;
    margin:10px 0;
    .report-head-son{
      width:33%;
      text-align: center;
      img{
        width:15px;
        height:15px;
      }
      div{
        font-size: 14px;
    line-height: 26px;
    padding-bottom: 5px;
    display: block;
    font-weight: 500;
      }
    }
  }
  .report-son{
    display:flex;
    justify-content: space-around;
    margin:10px 0.5%;
     .report-son-list{
       width:33%;
     }
     .list-head{
       text-align:center;
       border: 1px solid #ececec;
       background:#f5f5f5;
       height: 48px;
       line-height: 48px;
       font-size: 14px;
       border-right: 0;
       }
       .list-son{
         display:flex;
           align-items: center;
         align-content: center;
         padding-left:7%;
         height: 48px;
          border: 1px solid #ececec;
       line-height: 48px;
       font-size: 14px;
         img{
           width:15px;
           height:15px;
           margin-right:5px;
         }
       }
  }
}
.car_list_box {
  .title {
    display: flex;
    justify-content: space-between;
    margin: 5px 0;
    h3 {
      padding-left: 10px;
      border-left: 2px solid #2e71b8;
      font-weight: normal;
    }
  }
  .car_list {
    padding: 30px 0;
    position: relative;
    .imgUrl {
      position: absolute;
      width: 3.5rem;
      height: 3.5rem;
      left: 1rem;
    }
    .car_box {
      height: 295px;
      padding-bottom: 5px;
      .car_img {
        width: 100%;
        height: 210px;
      }
      .car_name {
        white-space: nowrap; /*超出的空白区域不换行*/
        overflow: hidden; /*超出隐藏*/
        text-overflow: ellipsis; /*文本超出显示省略号*/
        line-height: 2;
      }
      .car_text {
        display: flex;
        line-height: 2;
        font-size: 14px;
        color: #999;
        span {
          margin-right: 15px;
        }
      }
      .car_price {
        display: flex;
        justify-content: space-between;
        color: #2e71b8;
        font-size: 16px;
        font-weight: 700;
        .dealDate {
          color: #999;
          font-size: 14px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
